import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { resetServerContext } from 'react-beautiful-dnd';
import { getOrgTermsContent } from '../../../../content/utils.js';
import FieldGroup from '../../../FieldGroup.jsx';
import DatePickerAdapter from '../../../DatePickerAdapter.jsx';
import { FormError } from '../../../FormError.jsx';
import MultistepFormsFooter from '../../../MultistepFormsFooter.jsx';
import MultistepFormsNav from '../../../headers/FormHeaders/MultistepFormsNav.jsx';

const StepMilestonesFrom = (props) => {
  const {
    submitError,
    submitFailed,
    loading,
    handleSubmit,
    onCreateColumn,
    onDeleteColumn,
    onColumnNameChange,
    onColumnDateChange,
    updateNotes,
    data,
    values,
    onCancel,
    onBack,
  } = props;

  resetServerContext();

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <MultistepFormsNav
            activeIndex={3}
            onBack={onBack}
            onSubmit={handleSubmit}
            type="changeStrategy"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={8}>
          <p className="communication-help text-muted m-b-24">
            {getOrgTermsContent('projectMilestoneDescriptionForm')}
          </p>
        </Col>
      </Row>

      <Row className="m-b-60">
        <Col xs={12}>
          {data.length
            ? data.map((item, index) => (
                <React.Fragment key={`add-milestone-form-${index}`}>
                  <Row>
                    <Col xs={6}>
                      <div className="milestone-form">
                        <Field
                          name={`name${index}`}
                          className="m-0"
                          placeholder="Milestone Title"
                          type="text"
                          label={`${index + 1} ${getOrgTermsContent('projectMilestone')}`}
                        >
                          {(props) => (
                            <FieldGroup
                              {...props}
                              value={item[`name${index}`]}
                              onChange={(event) =>
                                onColumnNameChange(event.target.value, index)
                              }
                            />
                          )}
                        </Field>
                        <button
                          type="button"
                          className="btn-delete btn btn-default m-t-28"
                          onClick={() => onDeleteColumn(index)}
                        ></button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <Field
                        id={`initiativeFormStartDate${index}`}
                        name={`dateAt${index}`}
                        label="Date"
                        input={{ value: item[`dateAt${index}`] }}
                        placeholderText="Click to select"
                        component={DatePickerAdapter}
                        onChange={(event) => onColumnDateChange(event, index)}
                        allowNull
                      />
                    </Col>
                  </Row>
                  <Row className="m-b-10">
                    <Col xs={6}>
                      <Field
                        name={`notes${index}`}
                        componentClass="textarea"
                        component={FieldGroup}
                        rows={5}
                        customClass="fixed-height"
                        placeholder="Enter a Value"
                        className="m-0"
                        type="text"
                        label="Note"
                      >
                        {(props) => (
                          <FieldGroup
                            {...props}
                            value={item[`notes${index}`]}
                            onChange={(event) =>
                              updateNotes(event.target.value, index)
                            }
                          />
                        )}
                      </Field>
                    </Col>
                  </Row>
                </React.Fragment>
              ))
            : null}
        </Col>
        <Col xs={12}>
          <button
            // disabled={!data[data.length - 1].name}
            type="button"
            className="btn-link"
            onClick={onCreateColumn}
          >
            {' '}
            + Add a Milestone
          </button>
        </Col>
      </Row>
      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
      </Row>
      <Row>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={loading}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
          />
        </Col>
      </Row>
    </form>
  );
};

export default StepMilestonesFrom;
